import { getTimeWithGMT, parseISOString } from '@/core/lib/date';
import { formatTranslation } from '@/core/oddsApi/helpers/formatTranslation';
import type { KnockoutFragment, KnockoutMatchFragment, KnockoutTeamFragment, SboMatchFragment } from '@/core/oddsApi/oddsApiType';
import { EventStatus, TimezoneOffset, TournamentStage } from '@/interface/enum';
import type { IKnockoutStage, IKnockoutTeam, ISboEvent } from '@/interface/tournamentCenter';

function convertTeam(team: KnockoutTeamFragment | null | undefined): IKnockoutTeam | null {
    if (!team) {
        return null;
    }

    return {
        id: team.id,
        teamName: team.teamName.map(formatTranslation),
        countryName: team.countryName ?? '',
    };
}

function convertSboEvent(match: SboMatchFragment | null | undefined): ISboEvent | null {
    if (!match) {
        return null;
    }

    const home = match.finalScore?.home ?? 0;
    const away = match.finalScore?.away ?? 0;
    return {
        id: match.id ?? 0,
        homeTeam: convertTeam(match.homeTeam),
        awayTeam: convertTeam(match.awayTeam),
        finalScore: match.finalScore
            ? { home, away }
            : null,
        status: EventStatus.fromOddsApi(match.status),
    };
}

export function convertTournamentKnockout(knockout: KnockoutFragment): IKnockoutStage {
    return {
        stage: TournamentStage.fromOddsApi(knockout.stage),
        eventList: knockout.matchList.map((match: KnockoutMatchFragment) => ({
            datetime: match.datetime
                ? getTimeWithGMT(parseISOString(match.datetime), TimezoneOffset.Singapore)
                : null,
            regularEvent: convertSboEvent(match.regularMatch),
            extraTimeEvent: convertSboEvent(match.extraTimeMatch),
            penaltyEvent: convertSboEvent(match.penaltyMatch),
            homeTeam: convertTeam(match.homeTeam),
            awayTeam: convertTeam(match.awayTeam),
            homePlaceHolder: match.homePlaceHolder ?? null,
            awayPlaceHolder: match.awayPlaceHolder ?? null,
        })),
    };
}
